import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const adminRouter: Array<RouteConfig> = [
  {
    path: "checker_list/new_checker_account",
    name: "new_checker_account",
    component: () => import("@/views/Admins/CheckerCreate.vue"),
    meta: {
      permissionsRequired: [Permission.ADD_CHECKER]
    }
  },
  {
    path: "accounts",
    name: "admins_accounts",
    component: () => import("@/views/Admins/AdminList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_ADMIN]
    }
  },
  {
    path: "super_admin_list",
    name: "super_admin_accounts",
    component: () => import("@/views/Admins/SuperAdminList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_SUPER_ADMIN]
    }
  },
  {
    path: "accounts/new_account",
    name: "new_admin_account",
    component: () => import("@/views/Admins/NewAccount.vue"),
    meta: {
      permissionsRequired: [Permission.ADD_ADMIN]
    }
  },
  {
    path: "accounts/:id",
    name: "adminId",
    component: () => import("@/views/Admins/Admin.vue"),
    meta: {
      permissionsRequired: [Permission.EDIT_ADMIN]
    }
  },
  {
    path: "checkers_list/:id",
    name: "checkerId",
    component: () => import("@/views/Admins/SuperAdmin.vue"),
    meta: {
      permissionsRequired: [Permission.EDIT_CHECKER]
    }
  },
  {
    path: "",
    name: "admins",
    redirect: { name: "admins_accounts" }
  }
];

export default adminRouter;
